import MuiAppBar from '@mui/material/AppBar';
import MuiToolbar from '@mui/material/Toolbar';

/**
 * The application's top bar.
 *
 * `position="sticky"` rather than "fixed": sticky keeps the bar visible while a
 * long page scrolls but still occupies its own space in the layout, so the
 * first heading underneath is not hidden behind it. Fixed would need a spacer
 * element in every page to compensate.
 *
 * Its colours come from the MuiAppBar defaults in the theme, so the bar picks
 * up light and dark without this component knowing which is active.
 */
export function AppBarSurface({ children, ...rest }) {
  return (
    <MuiAppBar position="sticky" component="header" {...rest}>
      {children}
    </MuiAppBar>
  );
}

/** The horizontal bar inside AppBarSurface that holds its contents. */
export function Toolbar({ children, ...rest }) {
  return (
    <MuiToolbar disableGutters {...rest}>
      {children}
    </MuiToolbar>
  );
}
